import {ChangeDetectionStrategy, Component, OnInit} from '@angular/core';
import {ActivatedRoute} from '@angular/router';
import {Observable} from 'rxjs';
import {map} from 'rxjs/operators';
import {MarkdownFile, MarkdownLoaderService} from '../../services/markdown-loader.service';
import {Headline} from '../../services/markdown-parser.service';

@Component({
  selector: 'cc-markdown-container',
  templateUrl: './markdown-container.component.html',
  styleUrls: ['./markdown-container.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MarkdownContainerComponent implements OnInit {
  markdown$: Observable<MarkdownFile | undefined>;
  activeAnchor: string;

  headlines: Headline[] = [];

  constructor(private readonly route: ActivatedRoute, private readonly markdownLoaderService: MarkdownLoaderService) {
  }

  ngOnInit() {
    this.markdown$ = this.route.params.pipe(
      map(({ folder, file }) => this.markdownLoaderService.getMarkdown(folder, file)),
    );
  }
}
